var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.link)?_c('a',{staticClass:"button",class:{ 'no-bg': _vm.noBg, glow: _vm.glow, ['size-' + _vm.size]: true },attrs:{"href":_vm.link}},[_vm._t("default")],2):_c('button',{staticClass:"button",class:{ 'no-bg': _vm.noBg, glow: _vm.glow, ['size-' + _vm.size]: true },attrs:{"type":"button"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }